export function NewWorkOrder() {
    return (
        <div>
            New work order
        </div>
    );
}
